import * as React from "react";
import { Props } from "./types";
import Modal from "./Modal";

export default ({ patient, onClose, onFinish, onError }: Props) => {
  return <Modal patient={patient} onClose={onClose} onFinish={onFinish} onError={onError} />;
};
